import { isSSR } from '@front10/utils';

export function doRedirect({
  url,
  params,
  formData,
  method
}: {
  url: string;
  params: Record<string, string>;
  formData: Record<string, string>;
  method: string;
}) {
  if (isSSR()) {
    return;
  }
  if (method && method.toLocaleLowerCase() === 'post') {
    const form = document.createElement('form');
    form.setAttribute('method', 'POST');
    form.setAttribute('target', '_top');
    form.setAttribute('action', url);
    const data = params || formData;
    Object.keys(data).forEach((key) => {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', data[key]);

      form.appendChild(hiddenField);
    });

    document.body.appendChild(form);
    form.submit();
  } else {
    window.open(url, '_top');
  }
}
